import { render } from "./WidgetMenu.vue?vue&type=template&id=60ecdcbb&scoped=true"
import script from "./WidgetMenu.vue?vue&type=script&lang=js"
export * from "./WidgetMenu.vue?vue&type=script&lang=js"

import "./WidgetMenu.vue?vue&type=style&index=0&id=60ecdcbb&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ecdcbb"]])

export default __exports__